export default {
    login: {
        userName: "Nombre de Usuario",
        password: "Contraseña",
        login: "INICIAR SESSION",
    },
    navbar: {
        home: "Principal",
        contracts: "Contratos",
        settings: "Configuración",
        info: "Ayuda"
    },
    header: {
        home: "PRINCIPAL",
        contracts: "CONTRATOS",
        settings: "CONFIGURACIÓN",
        info: "AYUDA",
        contract: "CONTRATO",
        addService: "AÑADIR SERVICIO",
        service: "SERVICIO",
    },
    home: {
        hello: "Hola"
    },
    contracts: {
        active: "Activos",
        suspended: "Bajas",
        services: "Servicios",
        noSuspendedContracts: "No hay contratos de baja",
        noServices: "No hay servicios pendientes associados a este contrato",
        noPressupost: "No hay ningun pagamiento pendiente en este contrato",
        renovar: "Renovar contrato"
    },
    settings: {
        user: "USUARIO",
        closeSession: "Cerrar Sessión",
        settings: "CONFIGURACIÓN",
        appLanguage: "Idioma de la aplicación",
        confirmationText: "Seguro que quieres cerrar tu sessión?"
    },
    info: {

    },
    addService: {
        addTitle: "Solicitar un Servicio",
        editTitle: "Servicio",
        entrance: "Entrada al camping",
        exit: "Salida del camping",
        pickupAtParking: "Recoger caravana en el parking",
        deliveryAtParking: "Entregar caravana en el parking",
        doneText: "Hecho",
        cancelText: "Cancelar",
        transportDate: "Fecha del transporte",
        camping: "Camping",
        selectCamping: "-- Seleccionar --",
        parcel: "Parcela",
        selectParcel: "Selecciona la parcela",
        save: "Guardar",
		payment: "Pago",
		paymentTitle: "Pago del servicio",
		servicePaymentConfirm: "¿Estás seguro de que quieres proceder con el pago de este servicio?",
        toastMessage: "Tienes que llenar todos los campos para guardar!",

        requestService: "Solicitar el servicio",
        serviceSummary: "Resumen servicio",
        total: "Total",
        paidService: "Servicio pagado",
        transactionCompleted: "Transacción finalizada correctamente",
        serviceConfirm: "Estàs seguro de que quieres solicitar este servicio?",
        loading: "Pidiendo servicio...",

        reserveNum: "Numero de reserva",
        selectReserveNum: "Indica el numero",
        availableHoursInfo: "Horario disponible para el transporte: de {start} a {end}.",

        toastMessage2: "Para pedir un servicio antes de las proximas 48 horas ponte en contacto con nosotros."
    },
    service: {
        pending: "Pendiente",
        completed: "Finalizado",
        requestCompleted: "La petición de servicio se ha realizado correctamente"
    },
    contract: {
        entrance: "Entrada",
        exit: "Salida",
        registration: "Matrícula",
        initialDate: "Fecha inicial",
        finalDate: "Fecha final",
        zone: "Zona",
        parkType: "Tipo de parking",
        pendingServices: "Servicios Pendientes",
        completedServices: "Servicios Finalizados",
        pendingPressupost: "Pagos pendientes",
        pendingPressupostS: "Pago pendiente",
        pay: "Pagar",
        acceptConditions: "Aceptar los terminos y condiciones",
        acceptConditionsTitle: "Terminos y condiciones",
        contractNumberRequired: "Es necesario indicar el número de reserva para poder garantizar el transporte"
    },
    interceptors : {
        noAuthorized: "Usuario no autorizado"
    },
    payment: {
        confirmed: "Pago confirmado",
        confirmedExtended: "El pago se ha realizado con éxito",
        article: "Artículo",
        price: "Total",
        informEmail: "Recibirás un correo electrónico con los datos del pago",
        goBack: "Volver",
        denied: "Pago denegado",
        deniedExtended: "Ha habido un problema con el pago",
        deniedInfo: "Inténtalo de nuevo en unos minutos, y si el problema persiste, ponte en contacto con nosotros"
    }
};